import * as React from "react";
import { DataGrid, ptBR } from "@mui/x-data-grid";
import { connect } from "react-redux";
import { useEffect } from "react";
import { Button, Card, CardBody, CardTitle } from "reactstrap";
import CardHeader from "reactstrap/lib/CardHeader";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import moment from "moment";
import { Typography } from "@mui/material";
import { useState } from "react";
import {
  getAllEvents,
  createEvent,
  updateEvent,
  deleteEvent,
  getCalendars,
} from "redux/actions/Events";
import AvatarGroup from "@mui/material/AvatarGroup";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import CadastrarEvento from "./modals/cadastrar-evento";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditarEvento from "./modals/editar-evento";
import CadastrarEventosExcel from "./modals/cadastrar-eventos-excel";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { isMobile } from "react-device-detect";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

const theme = createTheme({
  palette: {
    primary: {
      main: "#007bff", // Altere a cor principal para a cor desejada
    },
    background: {
      default: "#f0f0f0", // Altere a cor de fundo padrão para a cor desejada
    },
  },
  components: {
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px", // Ajuste o espaçamento interno conforme necessário
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: 0,
          color: theme.palette.text.primary,
          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
            {
              outline: "none",
            },
          "& .MuiDataGrid-panelWrapper": {
            maxWidth: "calc(100vw - 4rem)",
          },
        }),
        panelWrapper: {
          maxWidth: "98vw",
        },
        toolbarContainer: ({ theme }) => ({
          alignItems: "baseline",
          paddingRight: `${theme.spacing(6)} !important`,
          paddingLeft: `${theme.spacing(3.25)} !important`,
          "& .MuiDataGrid-panelWrapper": {
            maxWidth: "calc(100vw - 4rem)",
          },
        }),
        columnHeaders: ({ theme }) => ({
          backgroundColor: "#F6F6F7",
        }),
        columnHeader: ({ theme }) => ({
          "&:not(.MuiDataGrid-columnHeaderCheckbox)": {
            paddingLeft: "10px",
            paddingRight: "10px",

            "&:first-of-type": {
              paddingLeft: "10px",
            },
          },
          "&:last-of-type": {
            paddingRight: "10px",
          },
        }),
        columnHeaderCheckbox: {
          maxWidth: "58px !important",
          minWidth: "58px !important",
        },
        columnHeaderTitleContainer: {
          padding: 0,
        },
        columnHeaderTitle: ({ theme }) => ({
          fontWeight: 600,
          letterSpacing: "1px",
          textTransform: "uppercase",
          fontSize: 12,
        }),
        columnSeparator: ({ theme }) => ({
          color: theme.palette.divider,
        }),
        row: {
          "&:last-child": {
            "& .MuiDataGrid-cell": {
              borderBottom: 0,
            },
          },
        },
        cell: ({ theme }) => ({
          borderColor: theme.palette.divider,
          "&:not(.MuiDataGrid-cellCheckbox)": {
            paddingLeft: "10px",
            paddingRight: "10px",
            "&:first-of-type": {
              paddingLeft: "10px",
            },
          },
          "&:last-of-type": {
            paddingRight: "10px",
          },
          "&:focus, &:focus-within": {
            outline: "none",
          },
        }),
        cellCheckbox: {
          maxWidth: "58px !important",
          minWidth: "58px !important",
        },
        editInputCell: ({ theme }) => ({
          padding: 0,
          color: theme.palette.text.primary,
          "& .MuiInputBase-input": {
            padding: 0,
          },
        }),
        footerContainer: ({ theme }) => ({
          alignItems: "baseline",
          borderTop: `1px solid ${theme.palette.divider}`,
          "& .MuiTablePagination-toolbar": {
            alignItems: "baseline",
            paddingLeft: `${theme.spacing(4)} !important`,
            paddingRight: `${theme.spacing(4)} !important`,
          },
          "& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel":
            {
              color: theme.palette.text.primary,
            },
        }),
        selectedRowCount: ({ theme }) => ({
          display: "none",
          margin: 0,
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
        }),
      },
    },
  },
});

const typeUnitTranslations = {
  minutes: "minuto",
  hours: "hora",
  days: "dia",
};
const typeUnitTranslationsPlural = {
  minutes: "minutos",
  hours: "horas",
  days: "dias",
};

const escapeRegExp = (value) => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

function Events(props) {
  const columns = [
    {
      minWidth: 20,
      width: 60,
      field: "actions",
      headerName: "",
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{ marginRight: 8, cursor: "pointer" }}
              title={"Editar"}
              onClick={() => handleEdit(params.row)}
            >
              <i style={{ fontSize: 15 }} className="fa fa-edit" />
            </div>
            <div
              style={{ cursor: "pointer" }}
              title={"Deletar"}
              onClick={() => handleDelete(params.row)}
            >
              <i style={{ fontSize: 15 }} className="fa fa-times" />
            </div>
          </div>
        );
      },
    },
    {
      flex: 1,
      field: "title",
      headerName: "Título",
      minWidth: 240,
      renderCell: (params) => (
        <Typography
          variant="body2"
          title={params.row.title}
          sx={{
            color: "text.primary",
            fontSize: "12px",
            fontWeight: "bold",
            maxHeight: "60px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {params.row.title}
        </Typography>
      ),
    },
    {
      field: "startDateTime",
      headerName: "Início",
      width: 110,
      type: "date",
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => (
        <React.Fragment>
          {!params.row.allDay ? (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.startDateTime).format("DD/MM/YYYY HH:mm")}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.startDateTime).format("DD/MM/YYYY")} Dia todo
            </Typography>
          )}
        </React.Fragment>
      ),
    },
    {
      field: "endDateTime",
      headerName: "Término",
      width: 110,
      type: "date",
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => (
        <React.Fragment>
          {!params.row.allDay ? (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.endDateTime).format("DD/MM/YYYY HH:mm")}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.endDateTime).format("DD/MM/YYYY")} Dia todo
            </Typography>
          )}
        </React.Fragment>
      ),
    },
    {
      field: "timezone",
      headerName: "Time Zone",
      width: 140,
      renderCell: (params) => (
        <div
          title={params.row.timezone}
          style={{
            maxHeight: "60px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 12,
          }}
        >
          {params.row.timezone}
        </div>
      ),
    },
    {
      flex: 1,
      field: "description",
      headerName: "Descrição",
      minWidth: 220,
      renderCell: (params) => (
        <div
          title={params.row.description}
          style={{
            maxHeight: "60px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 12,
          }}
        >
          {params.row.description}
        </div>
      ),
    },
    {
      field: "notifications",
      headerName: "Notificações",
      minWidth: 160,
      renderCell: (params) => (
        <div
          style={{
            maxHeight: "30px",
            overflow: "auto",
            whiteSpace: "pre-line",
            fontSize: 12,
          }}
        >
          {params.row.notifications.map((item) => (
            <div>
              {item.time}{" "}
              {item.time === 1
                ? typeUnitTranslations[item.typeUnit]
                : typeUnitTranslationsPlural[item.typeUnit]}{" "}
              - {item.type}
            </div>
          ))}
        </div>
      ),
    },
    {
      flex: 1,
      field: "guests",
      headerName: "Convidados",
      minWidth: 140,
      //valueGetter: (params) => params.value.join(", "),
      renderCell: ({ row }) => (
        <AvatarGroup max={6}>
          {row.guests?.map((email, index) => (
            <Tooltip key={index} title={email} arrow>
              <Avatar
                sx={{ bgcolor: "#007bff", width: 22, height: 22, fontSize: 12 }}
              >
                {email.substring(0, 2)}
              </Avatar>
            </Tooltip>
          ))}
        </AvatarGroup>
      ),
    },
  ];

  const [openEvento, setOpenEvento] = useState(false);
  const [openEditEvent, setOpenEditEvent] = useState(false);
  const [eventEdit, setEventEdit] = useState();
  const [openEventoExcel, setOpenEventoExcel] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);


  useEffect(() => {
    props.getAllEvents();
    props.getCalendars();

    if (document.documentElement.classList.length === 0) {
      document.documentElement.classList.toggle("nav-open", true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.eventCreate) {
      props.getAllEvents();
      toast.success("Evento adicionado com sucesso");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.eventCreate]);

  useEffect(() => {
    if (props.eventUpdate) {
      props.getAllEvents();
      toast.success("Evento atualizado com sucesso");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.eventUpdate]);

  useEffect(() => {
    if (props.eventDelete) {
      props.getAllEvents();
      toast.success("Evento deletado com sucesso");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.eventDelete]);

  useEffect(() => {
    if (refresh) {
      props.getAllEvents();
      setRefresh(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const handleEdit = (row) => {
    setEventEdit(row);
    setOpenEditEvent(true);
  };

  const handleDelete = (row) => {
    MySwal.fire({
      title: "Deletar?",
      text: `Tem certeza que gostaria de excluir o evento?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Deletar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-outline-primary ml-1",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
    }).then(function (result) {
      if (result.value) {
        props.deleteEvent(row);
      }
    });
  };

  // ** Converts table to CSV
  const exportToExcel = (table, fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(table);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const formatDateForExcel = (date) => {
    return { t: "d", v: new Date(date), z: XLSX.SSF._table[14] }; // O formato 14 representa "dd/mm/yyyy hh:mm" no Excel
  };

  const handleExportExcel = () => {
    let infos = filteredData.length ? filteredData : data;
    let dataInfo = infos.map((item) => {
      return {
        id: item.id,
        title: item.title,
        startDateTime: formatDateForExcel(item.startDateTime),
        endDateTime: formatDateForExcel(item.endDateTime),
        timezone: item.timezone,
        allDay: item.allDay,
        location: item.location,
        description: item.description,
        notifications: JSON.stringify(item.notifications),
        guests: item.guests?.join(","),
        calendar: item.calendar,
      };
    });
    exportToExcel(dataInfo, "Calendario-eventos");
  };

  const handleGetEvents = () => {
    props.getAllEvents();
  };

  const handleDeleteSelected = () => {
    MySwal.fire({
      title: "Deletar?",
      text: `Tem certeza que gostaria de excluir os eventos selecionados?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Deletar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-outline-primary ml-1",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
    }).then(function (result) {
      if (result.value) {
        // You can use the selectedRows state to get the selected items
        // and then delete them using the deleteEvent action.
        selectedRows.forEach((selectedId) => {
          const eventToDelete = data.find((event) => event.id === selectedId);
          if (eventToDelete) {
            props.deleteEvent(eventToDelete);
          }
        });
        // Clear the selection after deletion is completed
        setSelectedRows([]);
      }
    });
  };

  // Função para aplicar o filtro e atualizar os dados filtrados
  const handleApplyFilter = (filters) => {
    const activeFilters = filters.filter((filter) => !!filter.value);
    if (activeFilters.length === 0) {
      setFilteredData([]);
    } else {
      const filteredRows = data.filter((row) => {
        return Object.keys(row).some((field) => {
          return activeFilters.some((filter) => {
            const searchRegex = new RegExp(escapeRegExp(filter.value), "i");
            return (
              filter.field === field && searchRegex.test(row[field].toString())
            );
          });
        });
      });
      setFilteredData([...filteredRows]);
    }
  };

  return (
    <div >
      <CadastrarEvento
        open={openEvento}
        setOpen={setOpenEvento}
        createEvent={props.createEvent}
        calendars={props.calendars}
      />
      <CadastrarEventosExcel
        open={openEventoExcel}
        setOpen={setOpenEventoExcel}
        createEvent={props.createEvent}
        setRefresh={setRefresh}
        handleGetEvents={handleGetEvents}
      />
      <EditarEvento
        open={openEditEvent}
        setOpen={setOpenEditEvent}
        updateEvent={props.updateEvent}
        event={eventEdit}
        calendars={props.calendars}
      />
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Card>
        <CardHeader>
          <CardTitle>Eventos do calendário</CardTitle>
          <div>
            <Button
              color="primary"
              style={{ float: "right", width: 180, marginRight: 10 }}
              onClick={(e) => {
                setOpenEvento(true);
              }}
            >
              Cadastrar
            </Button>
            {!isMobile ? (
              <>
                <Button
                  style={{ float: "right", width: 180, marginRight: 10 }}
                  onClick={(e) => {
                    setOpenEventoExcel(true);
                  }}
                >
                  Importar Excel
                </Button>
                <Button
                  style={{ float: "right", width: 180, marginRight: 10 }}
                  onClick={handleExportExcel}
                >
                  Exportar excel
                </Button>
              </>
            ) : null}
          </div>
          {selectedRows.length > 0 ? (
            <Button
              style={{ float: "right", width: 180, marginRight: 10 }}
              onClick={handleDeleteSelected}
            >
              Deletar selecionados
            </Button>
          ) : null}
        </CardHeader>
        <CardBody style={{ height: 750 }}>
          <ThemeProvider theme={theme}>
            <DataGrid
              initialState={{
                sorting: {
                  sortModel: [{ field: "startDateTime", sort: "asc" }],
                },
              }}
              disableRowSelectionOnClick
              checkboxSelection
              onRowSelectionModelChange={(newSelection) =>
                setSelectedRows([...newSelection])
              }
              rowHeight={30}
              //rows={getFilteredData()} // Utilize a variável "filteredData" para renderizar os dados filtrados
              columns={columns}
              hideFooter
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: "1.125rem",
                },
              }}
              slotProps={{
                baseButton: {
                  size: "medium",
                  variant: "outlined",
                },
                toolbar: {
                  //value: "", // Remova o valor da barra de pesquisa
                  //clearSearch: () => setFilterModel({ items: [] }), // Limpe o filtro quando o usuário limpar a barra de pesquisa
                },
              }}
              rows={data}
              onFilterModelChange={(model) => handleApplyFilter(model.items)}
              localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
            />
          </ThemeProvider>
        </CardBody>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.events.data,
    eventCreate: state.events.eventCreate,
    eventUpdate: state.events.eventUpdate,
    eventDelete: state.events.eventDelete,
    calendars: state.events.calendars,
  };
};

export default connect(mapStateToProps, {
  getAllEvents,
  createEvent,
  updateEvent,
  deleteEvent,
  getCalendars,
})(Events);
